/**
 * @generated SignedSource<<eba13ec7b18b20d6f7b0cf480e70259d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentTypeInput = {
  document_id?: string | null | undefined;
  file?: AttachmentFileTypeInput | null | undefined;
  model_id: string;
  model_type: string;
  new_order?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type AttachmentFileTypeInput = {
  base64?: string | null | undefined;
  mime_type?: string | null | undefined;
  name?: string | null | undefined;
};
export type CreateAttachmentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AttachmentTypeInput;
};
export type CreateAttachmentMutation$data = {
  readonly createAttachment: {
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"AttachmentFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type CreateAttachmentMutation = {
  response: CreateAttachmentMutation$data;
  variables: CreateAttachmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAttachmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AttachmentEdge",
        "kind": "LinkedField",
        "name": "createAttachment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AttachmentFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateAttachmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AttachmentEdge",
        "kind": "LinkedField",
        "name": "createAttachment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "extension",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created_by",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "appendEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createAttachment",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b1d85827ec704831014c45ec142d8622",
    "id": null,
    "metadata": {},
    "name": "CreateAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAttachmentMutation(\n  $input: AttachmentTypeInput!\n) {\n  createAttachment(input: $input) {\n    cursor\n    node {\n      ...AttachmentFragment\n    }\n  }\n}\n\nfragment AttachmentFragment on Attachment {\n  id\n  name\n  extension\n  url\n  order\n  created_by\n}\n"
  }
};
})();

(node as any).hash = "b259599888fc8f0ec639c2b97103ab75";

export default node;
